// extracted by mini-css-extract-plugin
export var change = "_3i-1";
export var changeList = "_3i-0";
export var changePath = "_3i-2";
export var diffArrow = "_3i-5";
export var diffRow = "_3i-3";
export var diffValue = "_3i-4";
export var error = "_3i-8";
export var notice = "_3i-9";
export var result = "_3i-6";
export var success = "_3i-7";